import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { ExternalLink } from 'lucide-react';
import Footer from '../../components/public/Footer';
import { EMBED_URL, SHORT_URL } from '../../components/public/booking.config';

const translations = {
  En: { metaTitle: 'Book a Consultation | Janus Capital Strategy', title: 'Book a Consultation', fallback: 'Open in Google Calendar' },
  Fr: { metaTitle: 'Prendre rendez-vous | Janus Capital Strategy', title: 'Prendre rendez-vous', fallback: 'Ouvrir dans Google Calendar' }
};

export default function Book() {
  const [lang, setLang] = useState('En');

  useEffect(() => {
    const syncLang = () => {
      setLang((localStorage.getItem('januslang') || localStorage.getItem('janus_lang')) === 'Fr' ? 'Fr' : 'En');
    };
    syncLang();
    window.addEventListener('langchange', syncLang);
    window.addEventListener('januslangchanged', syncLang);
    return () => {
      window.removeEventListener('langchange', syncLang);
      window.removeEventListener('januslangchanged', syncLang);
    };
  }, []);

  const t = translations[lang] || translations.En;

  return (
    <div className="janus-page min-h-screen font-sans">
      <Helmet>
        <title>{t.metaTitle}</title>
        <meta name="robots" content="noindex, follow" />
      </Helmet>
      <div className="janus-container janus-section pt-32">
        <h1 className="mb-8 text-center text-3xl font-light uppercase tracking-widest text-[var(--color-black)]">{t.title}</h1>
        <div className="janus-white-stage mx-auto w-full max-w-4xl overflow-hidden">
          <iframe src={EMBED_URL} title={t.title} className="block h-[80vh] min-h-[640px] w-full border-0" />
        </div>
        <p className="mt-6 text-center">
          <a
            href={SHORT_URL}
            target="_blank"
            rel="noreferrer"
            className="inline-flex items-center gap-2 text-[10px] font-bold uppercase tracking-widest text-gray-500 transition hover:text-[var(--color-gold)]"
          >
            {t.fallback} <ExternalLink size={12} />
          </a>
        </p>
      </div>
      <Footer />
    </div>
  );
}
